
import Vue, { PropType } from 'vue';
import { Feature, InputBlockConfig, RadioButtonBlockConfig } from '@/types';
import ValidatedAttributeInput from '@/components/side-bar/content/blocks/sub-components/ValidatedAttributeInput.vue';

export default Vue.extend({
  name: 'radio-button-input-block',
  props: {
    config: { type: Object as PropType<RadioButtonBlockConfig>, required: true },
    parentFeature: { type: Object as PropType<Feature>, required: false },
    validationMethods: { type: Object, required: false },
    disabled: { type: Boolean, required: false, default: false },
    disabledReason: { type: String, required: false, default: '' },
  },
  components: { ValidatedAttributeInput },
  computed: {
    inputBlockConfig(): InputBlockConfig {
      return {
        type: this.config.type,
        key: this.config.key,
        label: this.config.label,
        attribute: this.config.attribute,
        required: this.config.required,
        // A null value will be considered a value and validated immediately
        //  but undefined will be ignored until the user selects something
        defaultValue: this.config.defaultOption ?? undefined,
      };
    },
  },
});
